import { Label } from "@patient-watch/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@patient-watch/ui/select";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

interface Props {
    name?: string;
    label?: string;
    required?: boolean;
}

const MonthYear: React.FC<Props> = ({ name = "date", label = "", required = false }) => {
    const { setValue, watch } = useFormContext();
    const [selectedMonth, setSelectedMonth] = useState<string>("");
    const [selectedYear, setSelectedYear] = useState<string>("");

    const months = [
        { value: "01", label: "January" },
        { value: "02", label: "February" },
        { value: "03", label: "March" },
        { value: "04", label: "April" },
        { value: "05", label: "May" },
        { value: "06", label: "June" },
        { value: "07", label: "July" },
        { value: "08", label: "August" },
        { value: "09", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
    ];

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, i) => currentYear + i);

    // Initialize from form value if it exists
    useEffect(() => {
        const formValue = watch(name);
        if (formValue && dayjs(formValue).isValid()) {
            const date = dayjs(formValue);
            setSelectedMonth(date.format("MM"));
            setSelectedYear(date.format("YYYY"));
        }
    }, [name, watch]);

    const updateFormValue = (month: string, year: string) => {
        if (month && year) {
            const isoDate = dayjs(`${year}-${month}-01`).toISOString();
            setValue(name, isoDate);
        } else {
            setValue(name, "");
        }
    };

    const handleMonthChange = (month: string) => {
        setSelectedMonth(month);
        updateFormValue(month, selectedYear);
    };

    const handleYearChange = (year: string) => {
        setSelectedYear(year);
        updateFormValue(selectedMonth, year);
    };

    return (
        <div className="flex flex-col gap-2">
            <Label htmlFor={name}>
                {label}
                {required && <span className="ml-0.5 text-red-500">*</span>}
            </Label>
            <div className="flex gap-2">
                <Select value={selectedMonth} onValueChange={handleMonthChange}>
                    <SelectTrigger id={`${name}-month`}>
                        <SelectValue placeholder="Month" />
                    </SelectTrigger>
                    <SelectContent>
                        {months.map((month) => (
                            <SelectItem key={month.value} value={month.value}>
                                {month.label}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>

                <Select value={selectedYear} onValueChange={handleYearChange}>
                    <SelectTrigger id={`${name}-year`}>
                        <SelectValue placeholder="Year" />
                    </SelectTrigger>
                    <SelectContent>
                        {years.map((year) => (
                            <SelectItem key={year} value={year.toString()}>
                                {year}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>
        </div>
    );
};

export default MonthYear;
